import cx from 'classnames';
import Styles from './mIndex.module.scss';

export interface ICommonPageModal {
  className?: string;
  title: string | React.ReactNode;
  description?: string;
  okText?: string | React.ReactNode;
  exitText?: string | React.ReactNode;
  isShowCloseIcon?: boolean;
  showExitBtn?: boolean;
  onCancel?: () => void;
  onExit?: () => void;
  onConfirm: () => void;
}

const CommonPageModal = ({
  title,
  onCancel,
  onExit,
  onConfirm,
  isShowCloseIcon = true,
  showExitBtn = true,
  className = '',
  description = '保存已添加内容，后续继续编辑',
  okText = '保存并退出',
  exitText = '退出',
}: ICommonPageModal) => {
  const handleCancel = () => {
    onCancel && onCancel();
  };

  const handleExit = () => {
    onExit && onExit();
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className={cx(Styles.root, className)}>
      <div className={Styles.wrapper}>
        {
          isShowCloseIcon && <div className={Styles.cancel} onClick={handleCancel} />
        }
        {
          title && <div className={Styles.title}>{title}</div>
        }
        <div className={Styles.description}>{description}</div>
        <div className={Styles.actions}>
          <div className={Styles.actionWrapper}>
            {showExitBtn && <div className={cx(Styles.action, Styles.exit)} onClick={handleExit}>{exitText}</div>}
            <div className={cx(Styles.action, Styles.confirm)} onClick={handleConfirm}>{okText}</div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default CommonPageModal;
